<template>
    <b-modal
        v-model="modal"
        :id="'rubric-skill-cell-update-'"
        :title="$t('rubrics.edit_description')"
        @ok="ok"
        :ok-disabled="value === '' || value.length > 120"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal rubric-skill-description">
        <div class="rubric-skill-description">
            <b-form-group
                :invalidFeedback="invalidFeedback"
                :state="state">
                <b-form-textarea
                    id="rubric-skill-description-textarea"
                    v-model="value"
                    :placeholder="$t('rubrics.give_feedback')"
                    rows="3">
                </b-form-textarea>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-rubric-edit-row-cell-description-update-component',
    props: {},
    data() {
        return {
            modal: false,
            value: '',
            cell: '',
            rowId: 0,
        };
    },
    methods: {
        show(column, rowID) {
            this.modal = true;
            this.column = column;
            this.rowId = rowID;
            this.cell = column.getCellForRow(rowID);
            this.value = this.cell ? this.cell.value : '';
        },

        ok() {
            if (this.cell) {
                this.updateValue();
            } else {
                this.storeValue();
            }
        },

        storeValue() {
            const data = {
                column_id: this.column.id,
                row_id: this.rowId,
                value: this.value,
            };

            this.axios.post(this.routes.addRubricCell(), data).then(
                (response) => {
                    this.column.addRelation('rubric_cells', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        updateValue() {
            const data = {
                value: this.value,
            };

            this.axios.post(this.routes.updateRubricCell(this.cell.id), data).then(
                (response) => {
                    this.cell.update(response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
    computed: {
        invalidFeedback() {
            if (this.value !== '' && this.value.length > 120) {
                const charsExceed = this.value.length - 120;
                return this.$tc('rubrics.you_have_x_characters_too_many_max_y', charsExceed, { max: 120 });
            }

            return this.$t('rubrics.provide_a_concise_description_of_max_x_characters', { max: 120 });
        },

        state() {
            return this.value !== '' && this.value.length <= 120 && this.value.length > 0;
        },
    },
};
</script>

<style scoped lang="scss"></style>
